import { createSlice } from "@reduxjs/toolkit";
import {
  createSharedResult,
  fetchSharedResult,
} from "../../actions/data/sharedResultAsyncActions";

export interface SharedResultState {
  createLink: {
    loading: boolean;
    error: string;
    shareId: string | null;
  };
  sharedData: {
    loading: boolean;
    error: string;
    errorStatus: number | null;
    data: any | null;
    photos: any[];
  };
}

const initialState: SharedResultState = {
  createLink: {
    loading: false,
    error: "",
    shareId: null,
  },
  sharedData: {
    loading: false,
    error: "",
    errorStatus: null,
    data: null,
    photos: [],
  },
};

const SharedResultSlice = createSlice({
  name: "SharedResultReducer",
  initialState,
  reducers: {
    resetCreateLink(state) {
      state.createLink = initialState.createLink;
    },
    resetSharedData(state) {
      state.sharedData = initialState.sharedData;
    },
    setSharedResultPhotos(state, action) {
      state.sharedData.photos = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(createSharedResult.pending, (state) => {
        state.createLink.loading = true;
        state.createLink.error = "";
        state.createLink.shareId = null;
      })
      .addCase(createSharedResult.fulfilled, (state, action) => {
        state.createLink.loading = false;
        state.createLink.shareId = action.payload.id;
      })
      .addCase(createSharedResult.rejected, (state, action) => {
        state.createLink.loading = false;
        state.createLink.error = action.payload as string;
      });

    builder
      .addCase(fetchSharedResult.pending, (state) => {
        state.sharedData.loading = true;
        state.sharedData.error = "";
        state.sharedData.errorStatus = null;
        state.sharedData.data = null;
      })
      .addCase(fetchSharedResult.fulfilled, (state, action) => {
        state.sharedData.loading = false;
        state.sharedData.data = action.payload;
      })
      .addCase(fetchSharedResult.rejected, (state, action) => {
        state.sharedData.loading = false;
        const payload = action.payload as { message: string; status: number | null } | undefined;
        state.sharedData.error = payload?.message ?? "Unknown error";
        state.sharedData.errorStatus = payload?.status ?? null;
      });
  },
});

export const { resetCreateLink, resetSharedData, setSharedResultPhotos } = SharedResultSlice.actions;
export const SharedResultReducer = SharedResultSlice.reducer;
